import Form from "./Form";
import "./App.css";
import { Provider } from "react-redux";
import store from "../redux/store";
import Footer from "./Footer";
import Header from "./Header";
import FAQ from "./Faq";
//import Share from "./Share";
import Uses from "./Uses";
import Content from "./Content";
import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";

function App() {
  return (
    <Provider store={store}>
      <div className="App">
        <Header />
        <div className="breadcrumb-main">
				<Breadcrumbs
					style={{ fontFamily: "Poppins" }}
					aria-label="breadcrumb"
				>
					<Link underline="hover" color="inherit" href="/">
						<span className="breadcrumb-link">Home</span>
					</Link>
					<Link
						underline="hover"
						color="inherit"
						>
						<span className="breadcrumb-link"><a style={{ color:"black" }} href="#">Business Tools</a></span>
					</Link>
					<Typography
						style={{ fontFamily: "Poppins" }}
						color="text.primary"
					>
						<span className="breadcrumb-link">
							<b>Email Signature Generator</b>
						</span>
					</Typography>
				</Breadcrumbs>
			</div>
        <Form />
        <FAQ />
		{/*<div style={{textAlign:"center"}}>
			<ins className="adsbygoogle leaderboard"
				style={{display:"block"}}
				data-ad-client="ca-pub-0671313638371673"
				data-ad-slot="6886527301"
				data-ad-format="auto"
				data-full-width-responsive="true">
			</ins>
		</div>*/}
        <Content />
		{/* <div style={{textAlign:"center"}}>
			<ins className="adsbygoogle rectangle"
				style={{display:"block"}}
				data-ad-client="ca-pub-0671313638371673"
				data-ad-slot="2475357625"
				data-ad-format="auto"
				data-full-width-responsive="true">
			</ins>
		</div>*/}
        <Uses />
        {/* <Share /> */}
		<div style = {{
			background: "#313131",
			border: "5px solid #313131"
		}}>
        <Footer />
		</div>
      </div>
    </Provider>
  );
}

export default App;